var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-helper"},[_c('icon',{attrs:{"type":"question-circle"}}),_c('div',{staticClass:"tooltip",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.text))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }